import { backend } from 'modules/data';
import { useMemo } from 'react';
import { messages } from 'shared/constants/countryNames';
import { useGetAmaxPayOpenBankingBanks } from 'shared/data/webApp/v1';

import { countryCodesWhitelist } from './ConnectBankAccountPopupContent.constants';

export const useBanks = (companyId: string, enabled: boolean, countryCode: backend.CountryCode | undefined) => {
    const { data, isLoading } = useGetAmaxPayOpenBankingBanks({ path: { companyId } }, { enabled });

    const banks = useMemo(
        () => (countryCode ? (data?.items || []).filter((bank) => bank.countries.includes(countryCode)) : []),
        [countryCode, data?.items]
    );

    const countries = useMemo(() => {
        const countriesSet = new Set<backend.CountryCode>();

        (data?.items || []).forEach((bank) => {
            bank.countries.forEach((countryCode) => {
                if (countryCodesWhitelist.includes(countryCode)) {
                    countriesSet.add(countryCode);
                }
            });
        });

        return [...countriesSet].map((countryCode) => ({
            id: countryCode,
            name: messages[countryCode],
        }));
    }, [data?.items]);

    return {
        banks,
        countries,
        isLoading,
    };
};
